var OverlayType;

(function (OverlayType) {
  OverlayType["Dark"] = "OVERLAY/DARK";
  OverlayType["Light"] = "OVERLAY/LIGHT";
  OverlayType["Loading"] = "OVERLAY/LOADING";
  OverlayType["Transparent"] = "OVERLAY/Transparent";
})(OverlayType || (OverlayType = {}));

export { OverlayType };
